<template>
  <div class="registrationFee">
    <div class="filter">
      <div class="filter_item">
        <div class="filter_item_label">医生</div>
        <el-select class="filter_item_select" v-model="form.doctorId" clearable filterable placeholder="请选择">
          <el-option v-for="doctor in doctorList" :key="doctor.value" :label="doctor.label" :value="doctor.value">
            <div class="doctor_option">
              <div class="doctor_option_label">{{ doctor.label }}</div>
              <div class="doctor_option_phone">{{ doctor.phone }}</div>
            </div>
          </el-option>
        </el-select>
      </div>
      <div class="filter_action">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        :data="list"
        border
        style="width: 100%">
        <el-table-column prop="doctorName" label="医生姓名" min-width="180"></el-table-column>
        <el-table-column prop="departments" label="科室" min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.departments.join('、') }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="deptName" label="医馆名称" min-width="180"></el-table-column>
        <el-table-column prop="registerFee" label="挂号费" min-width="180"></el-table-column>
        <el-table-column label="医保编码" min-width="180">
          <template slot-scope="scope">
            <div>未配置</div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="toEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        :current-page="pageNo"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="pageNoChange">
      </el-pagination>
    </div>

    <el-dialog
      title="编辑挂号费"
      class="editDialog"
      :visible.sync="editMap.visible"
      width="400px"
      :before-close="editClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="content">
        <el-form ref="form" :model="editMap.form" :rules="editMap.rules" label-width="100px">
          <el-form-item label="医生姓名：">
            <div>{{ editMap.form.doctorName }}</div>
          </el-form-item>
          <el-form-item label="科室：">
            <div>{{ editMap.form.departments.join('、') }}</div>
          </el-form-item>
          <el-form-item label="医馆名称：">
            <div>{{ editMap.form.deptName }}</div>
          </el-form-item>
          <el-form-item label="挂号费：" prop="registerFee">
            <el-input v-model.trim="editMap.form.registerFee" clearable placeholder="请输入挂号费" @input="registerFeeInput"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="editClose">取 消</el-button>
        <el-button type="primary" :loading="editMap.loading" @click="editConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { doctorList } from '@/api/doctor'

  import req from '@/utils/request'
  export default {
    name: 'registrationFee',
    data() {
      return {
        doctorList: [],
        form: {
          doctorId: ''
        },
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0,
        editMap: {
          visible: false,
          loading: false,
          rules: {
            registerFee: [{ required: true, message: '请输入挂号费', trigger: 'blur' }]
          },
          form: {
            id: '',
            doctorName: '',
            departments: [],
            deptName: '',
            registerFee: ''
          }
        }
      }
    },
    created () {
      this.getAllDoctor()
      this.getList()
    },
    methods: {
      async getAllDoctor () {
        const res = await doctorList({ status: 0, type: 0 })
        if (res.code == 200) {
          this.doctorList = res.rows.map(v => {
            return {
              label: v.doctorName,
              value: v.doctorId,
              phone: v.phone
            }
          })
        }
      },
      async getList () {
        const res = await req.post('/system/user/show-dept/doctors/page', {
          condition: {
            deptId: sessionStorage.getItem('deptId'),
            doctorId: this.form.doctorId
          },
          pageIndex: this.pageNo,
          pageSize: this.pageSize
        })
        this.list = res.data.records
        this.total = res.data.total
      },
      pageNoChange (pageNo) {
        this.pageNo = pageNo
        this.getList()
      },
      search () {
        this.pageNo = 1
        this.getList()
      },
      reset () {
        this.form = {
          doctorId: ''
        }
        this.pageNo = 1
        this.getList()
      },
      toEdit (row) {
        this.editMap.visible = true
        this.editMap.form = {
          id: row.id,
          doctorName: row.doctorName,
          departments: row.departments,
          deptName: row.deptName,
          registerFee: row.registerFee
        }
      },
      registerFeeInput(value) {
        const input = String(value || '').replace(/[^\d.]/g, '')
        const match = input.match(/^\d*(?:\.\d{0,2})?/)
        this.editMap.form.registerFee = match ? match[0] : ''
      },
      editClose () {
        this.editMap.visible = false
        this.editMap.form = {
          id: '',
          doctorName: '',
          departments: [],
          deptName: '',
          registerFee: ''
        }
        this.$refs.form.clearValidate()
      },
      async editConfirm () {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.editMap.loading = true
            const res = await req.put('/system/user/show-dept/doctors/register-fee', this.editMap.form)
            this.editMap.loading = false
            if (res.code == 200) {
              this.$message.success('编辑成功')
              this.editClose()
              this.getList()
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .registrationFee {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  .filter_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .filter_item_label {
    flex-shrink: 0;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
  }

  .filter_item_select {
    margin: 0 0 0 12px;
    width: 160px;
  }

  .doctor_option {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .doctor_option_label {
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .doctor_option_phone {
    margin: 0 0 0 12px;
    width: 100px;
    text-align: rightf;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .filter_action {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .table {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .table_title {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .editDialog /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .editDialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .editDialog /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .editDialog /deep/ .el-dialog__body {
    padding: 0px;
  }

  .editDialog /deep/ .el-dialog__footer {
    padding: 0px;
  }

  .content {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
  }

  .footer {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    border-top: 1px solid #EBEAEE;
  }
</style>
